import React, { useMemo } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import strings from "../Globalization/index";
import Model from '../models/model';
import { BarcodeModel } from './BarcodeTable';


const BarcodeTableGrid = BarcodeModel.createGridBase()

const actionRenderer = ({ row }) => {
	const { EndoScopeId } = row || {};
	return (
		<Button to={`/transactionlist?EndoScopeId=${EndoScopeId}`} component={Link} size='small' variant="outlined">{strings.Detail}</Button>
	);
}

const BarcodeGrid = ({ formik, activeRecord }) => {
	const endoScopeId = activeRecord.id;
	const parentFilters = useMemo(() => {
		return {
			filter: [{ "operator": "$eq", "value": endoScopeId, "property": "EndoScopeId", "type": "numeric" }]
		}
	}, [endoScopeId])
	const location = useLocation();
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	if (endoScopeId) {
		return (
			<Box sx={{ width: '75vw' }}>
				<Typography variant="h5" sx={{ color: 'primary.main' }}>
					Barcode
				</Typography>
				<BarcodeTableGrid
					parentFilters={parentFilters}
					onOpenForm={({ id, ...rest }) => {
						navigate(
							`/barcode?id=${id || 'new'}&EndoScopeId=${activeRecord.id}&returnTo=${location.pathname
							}?${searchParams.toString()}`
						);
					}}
					setActiveRecord={() => { }}
					readOnly={false}
				/>
			</Box>
		);
	}
}
const isShow = ({ formik }) => {
	return !formik.values.id;
}
const model = new Model({
	name: 'EndoScope',
	defaultSort: 'Name',
	formTitleField: 'Name',
	disableDelete: true,
	title: 'EndoScope',
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true
	},
	customizeSaveData: (saveData, { activeRecord }) => {
		if (activeRecord.id) {
			delete saveData.BarCode;
		}
		return saveData
	},
	formGroups: [{
		fields: ["Name", "SerialNumber", "EndoScopeModel", "HangTime", "EndoScopeLocationName", 'BarCode', "IsActive"]
	}],
	FormExtension: ({ formik, activeRecord }) => {
		return (<BarcodeGrid formik={formik} activeRecord={activeRecord} />)
	},

	columns: [
		{ header: strings.UniqueId, field: 'EndoScopeId', hidden: true, width: 250 },
		{ field: 'Name', width: 150, required: true, maxLength: 50 },
		{ field: 'HangTime', type: 'number', width: 150, required: true, minValue: 1, maxValue: 52, align: 'left', headerAlign: 'center', },
		{ header: 'SNo', field: 'SerialNumber', width: 150, required: true, maxLength: 50 },
		{ header: 'Barcode', field: 'BarCode', width: 150, required: true, inputWhen: isShow },
		{ field: 'EndoScopeModel', width: 150, required: true, maxLength: 50 },
		{ header: 'LocationName', field: 'EndoScopeLocationName', ignoreLookupOnGridFilter: true, lookup: 'Location', width: 150, required: true },
		{ header: 'Active', field: 'IsActive', type: 'bool', width: 130, required: true },
		{ header: 'Action', field: 'Action', width: 120, type: 'action', renderCell: actionRenderer, required: true, filterable: false, isNotExportField: true }
	]
});

export default model.createFormBase();
